import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
} from '@material-ui/core';
import { publicLogoPath } from '@orientaction/utils';
import layoutStyle from '../../../../components/Layout/style';
import { redesignTheme } from '../../theme';
import RedesignImage from '../components/RedesignImage';

type OAMatchDialogProps = {
  open: boolean;
  loading: boolean;
  text: {
    title: string;
    text: string;
    btnClose: string;
    btnAccess: string;
  };
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  onRedirect: () => void;
};

const OAMatchDialog = ({
  open,
  loading,
  text,
  onClose,
  onCancel,
  onConfirm,
  onRedirect,
}: OAMatchDialogProps) => {
  const cls = layoutStyle();

  return (
    <Dialog open={open} className={cls.modal} aria-labelledby="oa-common-popin">
      <DialogContent style={{ padding: 24 }}>
        <RedesignImage
          src={`${publicLogoPath}/e-orientaction.png`}
          alt="logo-orientation"
          className={cls.logoImg}
        />
        {text.title && (
          <p
            className={cls.textOADialog}
            style={{ fontFamily: redesignTheme.fonts.gothicBold, fontSize: 22 }}>
            {text.title}
          </p>
        )}
        {loading ? (
          <CircularProgress
            color="inherit"
            size={32}
            style={{ margin: '20px auto', display: 'block' }}
          />
        ) : (
          <p className={cls.textOADialog}>{text.text}</p>
        )}

        <div style={{ width: '100%' }}>
          <Grid container={true} spacing={2} direction="row" justifyContent="center" alignItems="center">
            <Grid item={true} xs={6}>
              <Button
                variant="outlined"
                className={cls.btnCancel}
                onClick={() => (text.title === '' ? onCancel() : onClose())}
                style={{ textTransform: 'none', lineHeight: 1.1 }}>
                {text.btnClose}
              </Button>
            </Grid>
            <Grid item={true} xs={6}>
              <Button
                id="confirmButton"
                style={{ textTransform: 'none', background: '#000A8C', lineHeight: 1.1 }}
                className={cls.btnConfirm}
                onClick={() => (text.title === '' ? onConfirm() : onRedirect())}
                data-cy="btn-on-confirm-modal">
                {text.btnAccess}
              </Button>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OAMatchDialog;
